"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _env = require("../../utils/env");

var _env2 = _interopRequireDefault(_env);

var _common = require("../../utils/common");

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BotManagerService = function BotManagerService(HttpService) {
  "ngInject";

  var getDataSource = function getDataSource(successCb, errorCb) {
    var dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: _env2.default.getApiUrl("bigfoot/bots/search"),
          contentType: "application/json",
          type: "POST",
          beforeSend: _onBeforeSend
        },
        update: {
          url: _getResourceLocation,
          contentType: "application/json",
          type: "PATCH",
          beforeSend: _onBeforeSend
        },
        create: {
          url: _env2.default.getApiUrl("bigfoot/bots/create"),
          contentType: "application/json",
          type: "POST",
          beforeSend: _onBeforeSend
        },
        parameterMap: _parameterMap
      },
      change: successCb,
      error: errorCb,
      schema: {
        data: "data",
        total: "total",
        model: {
          id: "id",
          fields: {
            "id": { type: "string" },
            "title": { type: "string", validation: { required: true } },
            "flowStatus": { type: "number", defaultValue: 0, validation: { required: true } },
            "flowFileBinary": {},
            "creationDate": { type: "date", editable: false }
          }
        }
      },
      serverFiltering: true,
      serverPaging: true,
      serverSorting: true,
      pageSize: 50
    });

    return dataSource;
  };

  return { getDataSource: getDataSource };
};

function _getResourceLocation(options) {
  return _env2.default.getApiUrl("bigfoot/bots/" + options.id);
}

function _onBeforeSend(req) {
  var token = "Bearer " + window.localStorage.getItem("bigfootAccessToken");

  req.setRequestHeader("Authorization", token);
}

function _parameterMap(data, type) {
  if (type == "read" || type == "create") {
    var filters = [];

    if (data.filter) filters = data.filter.filters;

    var query = (0, _assign2.default)({}, { filters: filters }, data);
    delete query.filter;

    console.log("Query::", query);

    return (0, _stringify2.default)(query);
  }

  if (type == "update") {

    // Dates used in the DataSource are JavaScript Date objects.
    // Therefore convert the date to utc before sending to remove dateoffset.

    //data.expireDate = common.converToUtcDate(data.expireDate);
    //data.startDate = common.converToUtcDate(data.startDate);

    console.log("update data", data);

    return (0, _stringify2.default)(data);
  }
}

exports.default = BotManagerService;


/** WEBPACK FOOTER **
 ** ./client/app/common/services/bot-manager.service.js
 **/